var _style, _defs, _polygon, _defs2, _polygon2, _defs3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignuPicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.28 62.64",
    style: {
      enableBackground: "new 0 0 71.28 62.64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000015321834781223991370000013190820470419048835_);fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000070839043617703072850000004314184657130113711_);fill:#FFFFFF;}\n\t.st3{clip-path:url(#SVGID_00000008866303765755848220000006325289565145107596_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.35,
    y: 0.3,
    width: 70.61,
    height: 61.99
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061460093998442632570000012063733936428824734_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000061460093998442632570000012063733936428824734_)",
      fill: "#FFFFFF"
    },
    d: "M1.97,60.68h47.98 V12.23L39.64,1.92H1.97V60.68z M50.75,62.3H1.16c-0.45,0-0.81-0.36-0.81-0.81V1.11c0-0.45,0.36-0.81,0.81-0.81h38.81 c0.21,0,0.42,0.09,0.57,0.24l10.78,10.78c0.15,0.15,0.24,0.36,0.24,0.57v49.59C51.56,61.93,51.2,62.3,50.75,62.3"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "39.97,11.89 50.75,11.89 39.97,1.11 "
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000159455409961936219240000006939590465247784121_",
    x: 0.35,
    y: 0.3,
    width: 70.61,
    height: 61.99
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120553095246318471800000000766197921548765330_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159455409961936219240000006939590465247784121_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120553095246318471800000000766197921548765330_)",
      fill: "#FFFFFF"
    },
    d: "M40.78,11.09h8.02 l-8.02-8.02V11.09z M50.75,12.7H39.97c-0.45,0-0.81-0.36-0.81-0.81V1.11c0-0.33,0.2-0.62,0.5-0.75c0.3-0.12,0.65-0.06,0.88,0.18 l10.78,10.78c0.23,0.23,0.3,0.58,0.18,0.88C51.38,12.51,51.08,12.7,50.75,12.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120553095246318471800000000766197921548765330_)",
      fill: "#FFFFFF"
    },
    d: "M19,33.97 c-0.2,0-0.39,0.08-0.58,0.25c-1.03,0.9-0.1,4.03,0.7,5.45c0.83,1.48,2.52,3.54,4.37,5.19c-0.07-3.17-0.62-6.42-1.57-8.08 c-0.73-1.28-1.87-2.63-2.77-2.79C19.1,33.98,19.05,33.97,19,33.97 M8.83,35.69c-0.14,0-0.24,0.03-0.33,0.07 c-1.24,0.52-0.88,3.29,0.11,5.76c0.54,1.35,2.04,3.4,3.87,5.41c-0.01-2.79-0.19-5.3-0.62-6.91c-0.54-2.01-1.6-3.74-2.56-4.21 C9.11,35.72,8.96,35.69,8.83,35.69 M12.79,57.98c-0.03,0-0.05,0-0.08,0c-0.44-0.04-0.77-0.44-0.73-0.88 c0.23-2.39,0.41-5.17,0.47-7.86c-2.49-2.51-4.62-5.33-5.34-7.12C5.86,39,5.4,35.3,7.88,34.27c0.69-0.29,1.42-0.26,2.13,0.09 c1.7,0.83,2.88,3.25,3.41,5.24c0.6,2.21,0.73,5.68,0.67,8.99c2.14,2.07,4.46,3.83,6.18,4.3c0.67,0.18,1.17,0.15,1.49-0.1 c1.02-0.78,1.57-3.13,1.71-5.85c-2.52-1.97-4.8-4.77-5.76-6.48c-0.76-1.36-2.44-5.64-0.34-7.46c0.6-0.52,1.32-0.73,2.06-0.61 c1.86,0.32,3.35,2.61,3.91,3.58c1.19,2.09,1.9,6.3,1.8,10.19c0.91,0.64,1.82,1.11,2.63,1.31c0.79,0.19,1.43,0.12,1.95-0.23 c0.97-0.65,1.19-1.97,0.84-5.07c-0.05-0.44,0.27-0.84,0.71-0.89c0.44-0.04,0.85,0.27,0.89,0.71c0.37,3.28,0.24,5.41-1.55,6.6 c-0.9,0.6-1.99,0.75-3.22,0.45c-0.77-0.19-1.56-0.55-2.36-1.02c-0.26,2.73-0.98,5.07-2.28,6.06c-0.75,0.57-1.73,0.69-2.9,0.37 c-1.7-0.47-3.8-1.91-5.81-3.71c-0.12,3.01-0.34,5.59-0.43,6.52C13.55,57.67,13.2,57.98,12.79,57.98"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120553095246318471800000000766197921548765330_)",
      fill: "#FFFFFF"
    },
    d: "M33.5,12.7H18.41 c-0.45,0-0.81-0.36-0.81-0.81c0-0.45,0.36-0.81,0.81-0.81H33.5c0.45,0,0.81,0.36,0.81,0.81C34.31,12.34,33.95,12.7,33.5,12.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120553095246318471800000000766197921548765330_)",
      fill: "#FFFFFF"
    },
    d: "M42.13,18.09H31.96 c-0.45,0-0.81-0.36-0.81-0.81c0-0.45,0.36-0.81,0.81-0.81h10.17c0.45,0,0.81,0.36,0.81,0.81C42.94,17.73,42.58,18.09,42.13,18.09"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120553095246318471800000000766197921548765330_)",
      fill: "#FFFFFF"
    },
    d: "M27.65,18.09H9.79 c-0.45,0-0.81-0.36-0.81-0.81c0-0.45,0.36-0.81,0.81-0.81h17.86c0.45,0,0.81,0.36,0.81,0.81C28.45,17.73,28.09,18.09,27.65,18.09"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120553095246318471800000000766197921548765330_)",
      fill: "#FFFFFF"
    },
    d: "M38.89,23.48H23.8 c-0.45,0-0.81-0.36-0.81-0.81c0-0.45,0.36-0.81,0.81-0.81h15.09c0.45,0,0.81,0.36,0.81,0.81C39.7,23.12,39.34,23.48,38.89,23.48"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120553095246318471800000000766197921548765330_)",
      fill: "#FFFFFF"
    },
    d: "M19.49,23.48h-9.7 c-0.45,0-0.81-0.36-0.81-0.81c0-0.45,0.36-0.81,0.81-0.81h9.7c0.45,0,0.81,0.36,0.81,0.81C20.3,23.12,19.94,23.48,19.49,23.48"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120553095246318471800000000766197921548765330_)",
      fill: "#FFFFFF"
    },
    d: "M28.19,28.88H9.79 c-0.45,0-0.81-0.36-0.81-0.81c0-0.45,0.36-0.81,0.81-0.81h18.4c0.45,0,0.81,0.36,0.81,0.81C29,28.51,28.63,28.88,28.19,28.88"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120553095246318471800000000766197921548765330_)",
      fill: "#FFFFFF"
    },
    d: "M36.17,33.42l-3.2,7.04 l7.04-3.2L69.28,7.98l-0.64-3.2l-3.2-0.64L36.17,33.42z M31.35,42.89c-0.21,0-0.42-0.08-0.57-0.24c-0.24-0.24-0.3-0.6-0.16-0.91 l4.15-9.13c0.04-0.09,0.1-0.17,0.16-0.24L64.61,2.7c0.19-0.19,0.46-0.27,0.73-0.22l4.15,0.83c0.32,0.06,0.57,0.31,0.63,0.63 l0.83,4.15c0.05,0.26-0.03,0.54-0.22,0.73L41.05,38.5c-0.07,0.07-0.15,0.12-0.24,0.16l-9.13,4.15 C31.57,42.87,31.46,42.89,31.35,42.89"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "44.97,23.48 49.12,24.31 49.95,28.46 40.48,37.93 39.65,33.78 35.5,32.95 "
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000055675944125055268820000002401502043977544123_",
    x: 0.35,
    y: 0.3,
    width: 70.61,
    height: 61.99
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149340264748282680140000002834264061273268120_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055675944125055268820000002401502043977544123_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000149340264748282680140000002834264061273268120_)",
      fill: "#FFFFFF"
    },
    d: "M37.14,32.45l2.67,0.53 c0.32,0.06,0.57,0.31,0.63,0.64l0.53,2.67l8.09-8.09L48.43,25l-3.2-0.64L37.14,32.45z M40.48,38.74c-0.08,0-0.16-0.01-0.24-0.03 c-0.28-0.09-0.5-0.32-0.56-0.62l-0.72-3.62l-3.62-0.72c-0.29-0.06-0.53-0.27-0.61-0.56c-0.09-0.28-0.01-0.6,0.2-0.81l9.47-9.47 c0.19-0.19,0.47-0.28,0.73-0.22l4.15,0.83c0.32,0.06,0.57,0.31,0.63,0.63l0.83,4.15c0.05,0.27-0.03,0.54-0.22,0.73l-9.47,9.47 C40.9,38.65,40.69,38.74,40.48,38.74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignuPicon);
export default __webpack_public_path__ + "static/media/SIGNUPicon.ed0ebe2ccd27f1944fb6f13fe57331ca.svg";
export { ForwardRef as ReactComponent };